import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import Layout from "../components/Layout";
import ProductDetails from "../components/ProductDetails.jsx";
// import MainMenu from "../components/MainMenu.jsx";

function Product({ productHandle: propHandle, collectionHandle: propCollection, legacyId }) {
  const params = useParams();

  const productHandle = propHandle || params.productHandle || null;
  const collectionHandle = propCollection || params.collectionHandle || null;
  const id = legacyId || params.id || null;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [productHandle, id]);

  const detailsKey = productHandle ? `handle:${productHandle}` : `id:${id || ""}`;

  return (
    <Layout>
      {/* <MainMenu /> */}
      <ProductDetails
        key={detailsKey}
        productHandle={productHandle}
        collectionHandle={collectionHandle}
        legacyId={id}
      />
    </Layout>
  );
}

export default Product;
